import { Button, Col, Image, Row } from 'react-bootstrap';
import { $form as $formSignal } from 'signals/global.signals';
import UniversalInput from 'components/global/UniversalInput';
import { DEAL_TYPE_OPTIONS, INVESTMENT_STAGE_OPTIONS } from 'components/global/DealForm/_helpers/dealForm.consts';
import getSelectValue from 'utils/getSelectValue';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileSelector from 'components/global/FileSelector/FileSelector';
import { handleInputChange } from 'components/global/_helpers/global.helpers';
import SimpleCard from 'components/global/SimpleCard';

const DealForm = ({
  onSubmit,
  buttonText = 'Create Deal',
  folders = [],
  $form = $formSignal,
}) => {
  const isDebtType = getSelectValue($form.value.typeOfRaise) === 'SAFE' || getSelectValue($form.value.typeOfRaise) === 'KISS' || getSelectValue($form.value.typeOfRaise) === 'Convertible Note';
  const isFirstRaise = getSelectValue($form.value.isFirstRaise) === true;
  return (
    <>
      <Row className="align-items-center">
        <Col md={6} lg={7} xl={8} xxl={9} className="mb-24 pe-0">
          <UniversalInput
            name="name"
            label="Deal Name"
            type="text"
            value={$form.value.name}
          />
        </Col>
        <Col md={6} lg={5} xl={4} xxl={3} className="mb-24 d-flex justify-content-end mt-24 ps-0">
          <Button
            variant="outline-info d-flex align-items-center"
            size="sm"
            className="bg-transparent border-0 text-muted"
          >
            <Image src="/images/ai-icon.svg" className="me-8" width={22} height={22} />
            Fill Using Latest Company Metrics - Coming Soon
          </Button>
        </Col>
        <Col lg={12} className="mb-24 border-top border-gray-400 pt-16">
          <h5 className="text-gray-400">Deal Details</h5>
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isFirstRaise"
            label="Is this the company's first raise?"
            type="select"
            value={$form.value.isFirstRaise}
            options={[
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="investmentStage"
            label="Investment Stage"
            type="select"
            value={$form.value.investmentStage}
            options={INVESTMENT_STAGE_OPTIONS}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="typeOfRaise"
            label="Type of Raise"
            type="select"
            value={$form.value.typeOfRaise}
            options={DEAL_TYPE_OPTIONS}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="currentValue"
            label="Company Valuation"
            type="money"
            value={$form.value.currentValue}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="currentRaiseSize"
            label="Current Raise Size"
            type="money"
            value={$form.value.currentRaiseSize}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="amountCommitted"
            label="Amount Committed"
            type="money"
            value={$form.value.amountCommitted}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="minimumInvestment"
            label="Minimum Investment"
            type="money"
            value={$form.value.minimumInvestment}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="fundingDate"
            label="Funding Date"
            type="date"
            value={$form.value.fundingDate}
          />
        </Col>
        <Col lg={12} className="mb-24">
          <UniversalInput
            name="usesOfCapital"
            label="Uses of Capital"
            type="textarea"
            value={$form.value.usesOfCapital}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="preMoneyValuation"
            label="Pre-Money Valuation"
            type="money"
            value={$form.value.preMoneyValuation}
          />
        </Col>
        <Col lg={12} className="mb-24 border-top border-gray-400 pt-16">
          <h5 className="text-gray-400">Previous Rounds</h5>
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="amountPreviouslyRaised"
            label="Amount Previously Raised"
            type="money"
            value={$form.value.amountPreviouslyRaised}
            disabled={isFirstRaise}
            placeholder={isFirstRaise ? 'Not Applicable for first raise' : ''}
          />
        </Col>
        <Col lg={12} className="mb-24 border-top border-gray-400 pt-16">
          <h5 className="text-gray-400">Debt Options</h5>
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="cap"
            label="Cap"
            type="money"
            value={isDebtType ? 0 : $form.value.cap}
            disabled={!isDebtType}
            placeholder={!isDebtType ? 'Not Applicable for non-debt deals' : ''}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="discountPercent"
            label="Discount Percent"
            type="percent"
            value={isDebtType ? 0 : $form.value.discountPercent}
            disabled={!isDebtType}
            placeholder={!isDebtType ? 'Not Applicable for non-debt deals' : ''}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="interestRate"
            label="Interest Rate"
            type="percent"
            value={$form.value.interestRate}
            disabled={!isDebtType}
            placeholder={!isDebtType ? 'Not Applicable for non-debt deals' : ''}
          />
        </Col>
        <Col lg={12} className="mb-24 border-top border-gray-400 pt-16">
          <h5 className="text-gray-400">Data Room</h5>
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isMrrIncluded"
            label="Include MRR?"
            type="checkbox"
            checked={$form.value.isMrrIncluded}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isArrIncluded"
            label="Include ARR?"
            type="checkbox"
            checked={$form.value.isArrIncluded}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isCashOnHandIncluded"
            label="Include Cash on Hand?"
            type="checkbox"
            checked={$form.value.isCashOnHandIncluded}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isCurrent"
            label="Include Investments?"
            type="checkbox"
            checked={$form.value.isCurrent}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isLiabilitiesIncluded"
            label="Include Liabilities?"
            type="checkbox"
            checked={$form.value.isLiabilitiesIncluded}
          />
        </Col>
        <Col lg={6} className="mb-24 d-flex flex-row align-items-end">
          <Button
            size="sm"
            variant="link"
            as="a"
            href="/founder/data-room?tab=Financials"
            target="_blank"
            rel="noopener noreferrer"
            className="text-info p-0"
          >
            <span className="me-8">Review Financials</span>
            <FontAwesomeIcon icon={faUpRightFromSquare} className="ms-4" size="sm" />
          </Button>
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="dataVaultInclusion"
            label="Data Vault Files"
            type="select"
            value={$form.value.dataVaultInclusion}
            options={[
              { label: 'Include All Files in Data Vault', value: 'all' },
              { label: 'Select Files to Include', value: 'select' },
            ]}
          />
        </Col>
        {getSelectValue($form.value.dataVaultInclusion) === 'select' && (
          <Col lg={12} xl={8} className="mb-24">
            <SimpleCard>
              <FileSelector
                folders={folders}
                onSelectionChange={(selectedDocs) => {
                  handleInputChange({ name: 'filesToInclude', value: selectedDocs });
                }}
                initialSelectedDocs={$form.value.filesToInclude}
              />
            </SimpleCard>
          </Col>
        )}
        <Col lg={12} className="mb-24 border-top border-gray-400 pt-16">
          <h5 className="text-gray-400">Visibility</h5>
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isCurrent"
            label="Is this your Primary Deal?"
            type="checkbox"
            checked={$form.value.isCurrent}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isActive"
            label="Is Active"
            type="checkbox"
            checked={$form.value.isActive}
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="isPublic"
            label="Is Public"
            type="checkbox"
            checked={$form.value.isPublic}
          />
        </Col>
      </Row>
      {buttonText && (
        <Row>
          <Col lg={12} className="mb-24">
            <Button onClick={onSubmit}>{buttonText}</Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default DealForm;
